import { useQuery } from '@tanstack/react-query';
import { firestoreService } from '../services/firestore.service';

export const useSchemes = () => {
  return useQuery({
    queryKey: ['schemes'],
    queryFn: () => firestoreService.getActiveSchemes(),
    staleTime: 10 * 60 * 1000,
  });
};

export const useScheme = (schemeId: string) => {
  return useQuery({
    queryKey: ['scheme', schemeId],
    queryFn: () => firestoreService.getSchemeById(schemeId),
    enabled: !!schemeId,
  });
};
